@if (!showForgotPassword()) {
  <!-- Login Form -->
  <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="md3-login-form">
    <!-- Error message -->
    @if (errorMessage()) {
      <div class="md3-alert md3-alert-error">
        <span class="md3-icon">error</span>
        <span>{{ errorMessage() }}</span>
      </div>
    }

    <!-- Email field -->
    <div class="md3-form-field">
      <input
        type="email"
        name="email"
        id="login-email"
        formControlName="email"
        class="md3-input"
        placeholder=" "
        autocomplete="email"
        aria-label="E-posta Adresi"
        required
        [class.error]="loginForm.get('email')?.invalid && loginForm.get('email')?.touched">
      <label for="login-email" class="md3-floating-label">E-posta Adresi</label>
      <span class="md3-icon md3-leading-icon">mail</span>

      @if (loginForm.get('email')?.invalid && loginForm.get('email')?.touched) {
        <div class="md3-error-text">
          @if (loginForm.get('email')?.hasError('required')) {
            <span>E-posta adresi gereklidir</span>
          }
          @if (loginForm.get('email')?.hasError('email')) {
            <span>Geçerli bir e-posta adresi girin</span>
          }
        </div>
      }
    </div>

    <!-- Password field -->
    <div class="md3-form-field">
      <input
        [type]="hidePassword() ? 'password' : 'text'"
        name="password"
        id="login-password"
        formControlName="password"
        class="md3-input"
        placeholder=" "
        autocomplete="current-password"
        aria-label="Şifre"
        required
        [class.error]="loginForm.get('password')?.invalid && loginForm.get('password')?.touched">
      <label for="login-password" class="md3-floating-label">Şifre</label>
      <span class="md3-icon md3-leading-icon">lock</span>

      <button type="button"
              class="md3-icon-button md3-trailing-icon"
              (click)="togglePasswordVisibility()"
              aria-label="Şifreyi göster/gizle"
              tabindex="-1">
        <span class="md3-icon">{{ hidePassword() ? 'visibility_off' : 'visibility' }}</span>
      </button>

      @if (loginForm.get('password')?.invalid && loginForm.get('password')?.touched) {
        <div class="md3-error-text">
          @if (loginForm.get('password')?.hasError('required')) {
            <span>Şifre gereklidir</span>
          }
          @if (loginForm.get('password')?.hasError('minlength')) {
            <span>Şifre en az 6 karakter olmalıdır</span>
          }
        </div>
      }
    </div>

    <!-- Remember me & Forgot password -->
    <div class="md3-form-options">
      <label class="md3-checkbox">
        <input type="checkbox" formControlName="rememberMe">
        <span class="md3-checkbox-checkmark"></span>
        <span class="md3-checkbox-label">Beni hatırla</span>
      </label>

      <button type="button" class="md3-text-button" (click)="toggleForgotPassword()">
        Şifremi unuttum
      </button>
    </div>

    <!-- Submit button -->
    <button type="submit"
            class="md3-button md3-button-filled md3-button-primary"
            [disabled]="loading() || loginForm.invalid">
      @if (loading()) {
        <span class="md3-circular-progress"></span>
        <span>Giriş yapılıyor...</span>
      } @else {
        <span class="md3-icon">login</span>
        <span>Giriş Yap</span>
      }
    </button>

    <!-- Divider -->
    <div class="md3-divider-with-text">
      <span>veya</span>
    </div>

    <!-- Google sign in -->
    <button type="button"
            class="md3-button md3-button-outlined md3-button-google"
            (click)="signInWithGoogle()"
            [disabled]="loading()">
      <svg class="google-icon" viewBox="0 0 24 24" width="20" height="20">
        <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
        <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
        <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
        <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
      </svg>
      <span>Google ile Giriş Yap</span>
    </button>

  </form>
} @else {
  <!-- Forgot Password Form -->
  <div class="md3-forgot-password-form">
    <div class="md3-form-header">
      <button type="button" class="md3-icon-button" (click)="backToLogin()">
        <span class="md3-icon">arrow_back</span>
      </button>
      <h2>Şifre Sıfırlama</h2>
    </div>

    @if (!forgotPasswordSent()) {
      <!-- Reset password form -->
      <div class="md3-form-description">
        E-posta adresinizi girin, size şifre sıfırlama bağlantısı gönderelim.
      </div>

      @if (forgotPasswordError()) {
        <div class="md3-alert md3-alert-error">
          <span class="md3-icon">error</span>
          <span>{{ forgotPasswordError() }}</span>
        </div>
      }

      <div class="md3-form-field">
        <input
          type="email"
          id="reset-email"
          class="md3-input"
          placeholder=" "
          [value]="forgotPasswordEmail()"
          (input)="forgotPasswordEmail.set($any($event.target).value)"
          [class.error]="forgotPasswordError()">
        <label for="reset-email" class="md3-floating-label">E-posta Adresi</label>
        <span class="md3-icon md3-leading-icon">mail</span>
      </div>

      <button type="button"
              class="md3-button md3-button-filled md3-button-primary"
              (click)="sendPasswordResetEmail()"
              [disabled]="forgotPasswordLoading() || !forgotPasswordEmail()">
        @if (forgotPasswordLoading()) {
          <span class="md3-circular-progress"></span>
          <span>Gönderiliyor...</span>
        } @else {
          <span class="md3-icon">send</span>
          <span>Sıfırlama Bağlantısı Gönder</span>
        }
      </button>
    } @else {
      <!-- Success message -->
      <div class="md3-success-container">
        <div class="md3-success-icon">
          <span class="md3-icon">check_circle</span>
        </div>
        <h3>E-posta Gönderildi!</h3>
        <p>
          <strong>{{ forgotPasswordEmail() }}</strong> adresine şifre sıfırlama bağlantısı gönderdik.
        </p>
        <p class="md3-text-secondary">
          E-postanızı kontrol edin ve bağlantıya tıklayarak yeni şifrenizi oluşturun.
          E-posta birkaç dakika içinde gelmezse, spam klasörünü kontrol edin.
        </p>
        <button type="button"
                class="md3-button md3-button-filled md3-button-primary"
                (click)="backToLogin()">
          <span class="md3-icon">arrow_back</span>
          <span>Girişe Dön</span>
        </button>
      </div>
    }
  </div>
}